import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { auth } from './Firebase';
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { db } from './Firebase';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Zapisz imię w Firestore
      await setDoc(doc(db, 'users', user.uid), {
        name: name,
        email: email,
        createdAt: new Date().toISOString(),
      });

      // Wyślij email weryfikacyjny
      await sendEmailVerification(user);
      setError('Zarejestrowano! Sprawdź swoją skrzynkę email (również spam) i zweryfikuj konto. Po weryfikacji zaloguj się.');
      // Dłuższe opóźnienie dla synchronizacji
      setTimeout(() => navigate('/login'), 10000); // 10 sekund opóźnienia
    } catch (err) {
      let errorMessage = 'Błąd rejestracji. Sprawdź dane.';
      switch (err.code) {
        case 'auth/email-already-in-use':
          errorMessage = 'Ten email jest już w użyciu.';
          break;
        case 'auth/invalid-email':
          errorMessage = 'Nieprawidłowy format email.';
          break;
        case 'auth/weak-password':
          errorMessage = 'Hasło musi mieć co najmniej 6 znaków.';
          break;
        case 'auth/network-request-failed':
          errorMessage = 'Błąd połączenia. Sprawdź internet.';
          break;
        default:
          errorMessage = `Błąd: ${err.message}`;
      }
      setError(errorMessage);
      console.error('Błąd rejestracji:', err);
    }
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 5, p: 2 }}>
      <Typography variant="h5" gutterBottom>Rejestracja</Typography>
      {error && <Alert severity={error.includes('Zarejestrowano') ? 'success' : 'error'}>{error}</Alert>}
      <form onSubmit={handleRegister}>
        <TextField
          label="Imię"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          margin="normal"
          type="email"
          required
        />
        <TextField
          label="Hasło"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          margin="normal"
          type="password"
          required
        />
        <Button type="submit" variant="contained" sx={{ mt: 2 }}>
          Zarejestruj się
        </Button>
      </form>
    </Box>
  );
};

export default Register;